import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { RangeSlider } from "components";
import { budgetFormat } from "components/UnitsView/utils";
import { setActiveOptionComp } from "slices";
import { createEventSignal } from "utils/methods/index";
import { getAppSSID } from "slices/window-slice/index";
import { selectPropertyId } from "slices/property-slice/index";

const HandleRangeSlider = ({ activeOptionComp, handleClick }) => {
  const { componentOptions, optionsType } = activeOptionComp || {};
  const dispatch = useDispatch();
  const SSID = useSelector(getAppSSID);
  const propertyId = useSelector(selectPropertyId);

  const handleRangeSelect = (v) => {
    dispatch(setActiveOptionComp(null));

    const newMessage = [{ message: budgetFormat(v), speaker: "user", optionsType, createdAt: new Date() }];
    const callbackOptions = { ...componentOptions.callbackOptions, data: { ...componentOptions.callbackOptions.data, data: v } };
    let eventKeys = JSON.parse(localStorage.getItem(`events_${SSID}`)) || [];
    eventKeys.push("custom price range");
    localStorage.setItem(`events_${SSID}`, JSON.stringify(eventKeys));

    const requestOption = {
      tag: "FAA_CUSTOM_PRICE_RANGE",
      metric: "Surprise",
      propertyId: propertyId,
      sessionId: SSID,
      appSubsection: "Find an apartment",
    };
    createEventSignal(requestOption);
    handleClick(newMessage, callbackOptions);
  };

  const range = componentOptions?.callbackOptions?.data.data || [0, 0];

  return <RangeSlider range={range} onSelect={handleRangeSelect} />;
};

export default HandleRangeSlider;
